import SectionHeading from "@/pages/home/components/SectionHeading";
import { downloadItems } from "@/mocks/home";

export default function DownloadSection() {
  return (
    <section id="app-download" className="scroll-mt-28 py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="APP下载"
          title="按你的设备选择安装包"
          desc="不同系统的安装方式略有差别，下载前请先核对版本号、文件大小与系统要求，安装完成后即可获得更稳定的播放体验。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-5">
          {downloadItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col p-5 md:p-6 rounded-lg border border-background-200 bg-background-50"
            >
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <span className="text-xs font-label font-medium text-secondary-700 bg-secondary-100/80 rounded-full px-2.5 py-0.5">
                    {item.platform}
                  </span>
                  <h3 className="mt-2 font-heading font-bold text-lg text-foreground-950">
                    {item.packageName}
                  </h3>
                </div>
              </div>

              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>

              <dl className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
                <div className="p-2.5 rounded-md bg-background-100">
                  <dt className="text-xs text-foreground-500">版本</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-900">{item.version}</dd>
                </div>
                <div className="p-2.5 rounded-md bg-background-100">
                  <dt className="text-xs text-foreground-500">大小</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-900">{item.size}</dd>
                </div>
                <div className="p-2.5 rounded-md bg-background-100">
                  <dt className="text-xs text-foreground-500">更新</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-900">{item.updated}</dd>
                </div>
                <div className="p-2.5 rounded-md bg-background-100">
                  <dt className="text-xs text-foreground-500">系统</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-900">{item.requirement}</dd>
                </div>
              </dl>

              <div className="mt-5 flex items-center gap-3">
                <a
                  href="#latest-address"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-download-2-line" aria-hidden="true" />
                  获取安装包
                </a>
                <a
                  href="#access-guide"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看安装教程
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}